import React, { useEffect, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import Modal from 'react-modal';
import { GetHSNChapterandCreateHSNChapter, GetHSNClassificationandCreateHSNClassification, GetHSNHeadingandCreateHSNHeading, GetHSNSubheadingandCreateHSNSubheading, UpdateHSNChapterandDeleteHSNChapter, UpdateHSNClassificationandDeleteHSNClassification, UpdateHSNHeadingandDeleteHSNHeading, UpdateHSNSubheadingandDeleteHSNSubheading } from "../../../../services/ProductService/HSNMgt/HSNManagement";
import SACCodeSelect from "./SACCodeSelect";
// import DeletePopUp from "../../../../pages/LADProducts/HSNMgt/Delete PopUp/DeletePopUp";
// import AddNewHSNHeading from "../../../../pages/LADProducts/HSNMgt/Add New HSN Heading/AddNewHSNHeading";
// import AddNewHSNSubheading from "../../../../pages/LADProducts/HSNMgt/Add New HSN Subheading/AddNewHSNSubheading";
// import AddNewClassifications from "../../../../pages/LADProducts/HSNMgt/Add New Classificaation/AddNewClassifications";

const SelectSACModal = ({ onSelectedHSN, onCreateRfq, AllDatas }) => {

    const [searchData, setSearchData] = useState()
    // const [chapter, setChapter] = useState([]);
    // const [heading, setHeading] = useState([]);
    // const [subheading, setSubheading] = useState([]);
    // const [filteredChapter, setFilteredChapter] = useState([]);
    // const [filteredHeading, setFilteredHeading] = useState([]);
    // const [filteredSubheading, setFilteredSubheading] = useState([]);
    const [filteredClassifications, setFilteredClassifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);
    const [showAddHeadingPopup, setShowAddHeadingPopup] = useState(false);
    const [showAddSubHeadingPopup, setShowAddSubHeadingPopup] = useState(false);
    const [showAddClassificationPopup, setShowAddClassificationPopup] = useState(false);
    const [chapterCode, setChapterCode] = useState(null);
    const [headingCode, setHeadingCode] = useState(null);
    const [subheadingCode, setSubheadingCode] = useState(null);
    const [subheadingId, setSubheadingId] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    // const [searchdata, setSearchdata] = useState(false);

    // Handle Add New Popups
    const handleHeadingNewAdd = (chapterCode) => {
        setShowAddHeadingPopup(true);
        setChapterCode(chapterCode);
    };

    const handleSubHeadingNewAdd = (chapterCode, headingCode) => {
        setShowAddSubHeadingPopup(true);
        setChapterCode(chapterCode);
        setHeadingCode(headingCode);
    };

    const handleClassificationNewAdd = (chapterCode, headingCode, subheadingCode, subheadingId) => {
        setShowAddClassificationPopup(true);
        setChapterCode(chapterCode);
        setHeadingCode(headingCode);
        setSubheadingCode(subheadingCode);
        setSubheadingId(subheadingId);
    };

    const [selectedHSNCode, setSelectedHSNCode] = useState('')

    const getSpecifieddata = (AllDatas) => {

    }

    const handleSelectHSN = (selectedHSNData) => {
        if (!selectedHSNData || !selectedHSNData.code) return;

        setSelectedHSNCode(selectedHSNData.code);
        if (typeof onSelectedHSN === 'function') {
            onSelectedHSN({
                ...selectedHSNData,
                id: selectedHSNData.id || null,
                code: selectedHSNData.code || ''
            });
        }
        setIsModalOpen(false); // Close modal after selection
    };

    const fetchAllData = async (AllDatas) => {
        setLoading(true);
        try {
            const classificationRes = await GetHSNClassificationandCreateHSNClassification('GET', {});
            setFilteredClassifications(classificationRes.data);

            if (AllDatas) {
                const getSpecificdata = classificationRes.data.find((item) => item.classification_code === AllDatas.p_hsn_code_no)
                if (getSpecificdata) {
                    setSelectedHSNCode(getSpecificdata.classification_code);// Assuming `code` is the key
                    onSelectedHSN?.({ type: 'classification', id: getSpecificdata.id, code: getSpecificdata.classification_code });
                }
            }
        } catch (err) {
            console.error("Error fetching classifications:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleItemDelete = async (id) => {
        try {
            await UpdateHSNClassificationandDeleteHSNClassification('DELETE', id);
            setFilteredClassifications(prev => prev.filter(c => c.id !== id));
            setShowDeletePopup(false);
            fetchAllData(); // Refresh the classifications list
        } catch (err) {
            console.error("Error deleting classification:", err);
        }
    };

    useEffect(() => {
        fetchAllData(AllDatas);
    }, []);

    return (

        <div>

            <div className="flex flex-col">
                {onCreateRfq ? (<></>) : (
                    <label htmlFor="productName" className="font-semibold text-[#667085]">
                        HSN Code Select
                    </label>
                )}
                <div className="flex w-full space-x-2 items-center">
                    {onCreateRfq ? (<input
                        id="HsnCode"
                        type="text"
                        placeholder="Enter Company Name"
                        className="w-full border-2 p-2 rounded-xl outline-none"
                        name="hsn_code_id"
                        readOnly
                        value={selectedHSNCode} // ✅ Show code instead of id    || productDetailsdata.p_hsn_code}
                    // onChange={handleChange}
                    />) : (<input
                        id="HsnCodeProduct"
                        name="p_hsn_code"
                        value={selectedHSNCode} // ✅ Show code instead of id    || productDetailsdata.p_hsn_code}
                        // onChange={handleChange}
                        placeholder="Enter Product HSN Code....."
                        type="text"
                        readOnly
                        className="flex-1 p-2 border border-gray-300 rounded-md outline-sky-300"
                    />)}

                    <button
                        type="button"
                        onClick={() => setIsModalOpen(true)} // Open the modal
                        className="bg-[#0C92CC] px-5 py-2 text-white rounded-md outline-sky-300"
                    >
                        Select
                    </button>
                </div>
            </div>

            {isModalOpen && (
                <Modal
                    isOpen={isModalOpen}
                    className="bg-white p-6 rounded-lg shadow-lg w-2/4 mx-auto z-50 h-2/3 font-normal"
                    overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                >
                    {/* Header */}
                    <div className="flex items-center justify-between py-2 border-b border-gray-300">
                        <div>
                            <h1 className="text-2xl font-bold">Select HSN Code</h1>
                            <p className="text-sm text-gray-500">
                                You can select only one HSN Code.
                            </p>
                        </div>
                        <IoMdClose
                            className="cursor-pointer text-2xl font-bold"
                            onClick={() => setIsModalOpen(false)} />
                    </div>
                    {/* Search */}
                    <div className="flex items-center justify-center gap-3 py-5">
                        <div className="relative border w-2/3">
                            <input
                                type="text"
                                placeholder="Search categories or subcategories..."
                                className="rounded-md border-none px-4 py-2 w-full bg-blue-100 outline-blue-100"
                                value={searchData}
                                onChange={(e) => setSearchData(e.target.value)} />
                            <FaSearch className="absolute right-3 top-3 text-gray-500" />
                        </div>
                        <button
                            className="text-blue-700 border border-blue-200 rounded-xl px-5 py-2"
                            onClick={() => setSearchData('')}>
                            Clear
                        </button>
                    </div>
                
                    <SACCodeSelect
                        SearchData={searchData}
                        // chapter={filteredChapter}
                        // heading={filteredHeading}
                        // subheading={filteredSubheading}
                        classifications={filteredClassifications}
                        setShowDeletePopup={setShowDeletePopup}
                        setShowAddHeadingPopup={handleHeadingNewAdd}
                        setShowAddSubHeadingPopup={handleSubHeadingNewAdd}
                        setShowAddClassificationPopup={handleClassificationNewAdd}
                        setItemToDelete={setItemToDelete}
                        selectedHSNData={handleSelectHSN}
                        onClose={() => setIsModalOpen(false)} />

                </Modal>
            )}


            {/* {showDeletePopup && (
                <DeletePopUp
                    onConfirm={() => handleItemDelete(itemToDelete.id, itemToDelete.code, itemToDelete.type)}
                    onCancel={() => setShowDeletePopup(false)}
                    code={itemToDelete.code}
                    isChapter={itemToDelete.type}
                />
            )}


            {showAddHeadingPopup && (
                <AddNewHSNHeading
                    onCancel={() => setShowAddHeadingPopup(false)}
                    chapterCode={chapterCode}
                    added={fetchAllData}
                />
            )}

            {showAddSubHeadingPopup && (
                <AddNewHSNSubheading
                    onCancel={() => setShowAddSubHeadingPopup(false)}
                    chapterCode={chapterCode}
                    headingcode={headingCode}
                    added={fetchAllData}
                />
            )}

            {showAddClassificationPopup && (
                <AddNewClassifications
                    onCancel={() => setShowAddClassificationPopup(false)}
                    chapterCode={chapterCode}
                    headingcode={headingCode}
                    subheadingcode={subheadingCode}
                    subheadingId={subheadingId}
                    added={fetchAllData}
                />
            )} */}

        </div>
    );
};

export default SelectSACModal;
